
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rat-race",
      function () {
        return require("private-next-pages/rat-race/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rat-race"])
      });
    }
  